var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectParking2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1270,
    viewBox: "0 0 2500 1270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M112 723H37V581H112V723Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M176 724H112V581H176V724Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "107-108",
    d: "M176 1074H112V843H176V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "99-100",
    d: "M578 1074H510V843H578V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "13-14",
    d: "M844 729H776V501H844V729Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M578 724H513V581H578V724Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M310 724H247V581H310V724Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "91-92",
    d: "M983 1074H910V843H983V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "103-104",
    d: "M305 1074H240V843H305V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "95-96",
    d: "M715 1074H642V843H715V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "17-18",
    d: "M981 729H907V501H981V729Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: 10,
    d: "M715 724H652V581H715V724Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M442 724H379V581H442V724Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "87-88",
    d: "M1118 1074H1040V843H1118V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "85-86",
    d: "M1191 1074H1118V843H1191V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: 84,
    d: "M1253 976H1191V843H1253V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: 83,
    d: "M1311 976H1253V843H1311V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "81-82",
    d: "M1388 976H1311V746H1388V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "79-80",
    d: "M1457 976H1388V746H1457V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "71-72",
    d: "M1860 976H1791V746H1860V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "63-64",
    d: "M2260 976H2199V746H2260V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "49-50",
    d: "M2262 643H2199V403H2262V643Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "41-42",
    d: "M1993 643H1924V403H1993V643Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "29-30",
    d: "M1456 643H1386V403H1456V643Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "19-20",
    d: "M1043 729H981V501H1043V729Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "27-28",
    d: "M1386 643H1316V403H1386V643Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "75-76",
    d: "M1589 976H1521V746H1589V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "59-60",
    d: "M2396 976H2329V746H2396V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "67-68",
    d: "M1992 976H1924V746H1992V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "53-54",
    d: "M2396 643H2329V403H2396V643Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "45-46",
    d: "M2128 643H2061V403H2128V643Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "33-34",
    d: "M1590 644H1523V403H1590V644Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "61-62",
    d: "M2329 976H2260V746H2329V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "77-78",
    d: "M1521 976H1457V746H1521V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "69-70",
    d: "M1924 976H1860V746H1924V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "57-58",
    d: "M2467 976H2396V746H2467V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "51-52",
    d: "M2329 643H2262V403H2329V643Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "43-44",
    d: "M2061 643H1993V403H2061V643Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "31-32",
    d: "M1523 643H1456V403H1523V643Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "21-22",
    d: "M1118 729H1043V501H1118V729Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "73-74",
    d: "M1656 976H1589V746H1656V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "65-66",
    d: "M2059 976H1992V746H2059V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "55-56",
    d: "M2467 643H2396V403H2467V643Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "47-48",
    d: "M2199 643H2128V403H2199V643Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "35-36",
    d: "M1661 644H1590V403H1661V644Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: 26,
    d: "M1316 644H1251V501H1316V644Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: 25,
    d: "M1251 644H1191V501H1251V644Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "23-24",
    d: "M1191 729H1118V501H1191V729Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: 40,
    d: "M1924 644H1860V519H1924V644Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: 38,
    d: "M1793 644H1725V519H1793V644Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: 39,
    d: "M1860 644H1793V519H1860V644Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: 37,
    d: "M1725 644H1659V519H1725V644Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "109-110",
    d: "M112 1074H37V843H112V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "101-102",
    d: "M510 1074H442V843H510V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "11-12",
    d: "M776 729H715.158V581.26H708V501H776V729Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M513 724H442V581H513V724Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M247 724H176V581H247V724Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "93-94",
    d: "M910 1074H849V843H910V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "105-106",
    d: "M240 1074H176V843H240V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "97-98",
    d: "M642 1074H578V843H642V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "15-16",
    d: "M907 729H844V501H907V729Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: 9,
    d: "M652 724H578V581H652V724Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M379 724H310V581H379V724Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "89-90",
    d: "M1040 1074H983V843H1040V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectParking2);
export default __webpack_public_path__ + "static/media/select-parking-2.d9eb9ca5.svg";
export { ForwardRef as ReactComponent };